import OrganisationTypeEnum from '@constants/enums/organisation/type';

import ProviderApi from '@packages/providers/api';

import { Organisation, Product } from '@/models';

export class Provider extends Organisation {
    static name = 'Provider';
    static entity = 'providers';
    static Api = ProviderApi;

    static fields() {
        return {
            ...super.fields(),
            type: this.enum(OrganisationTypeEnum, OrganisationTypeEnum.PRODUCT_PROVIDER).nullable(),
            products: this.hasMany(Product, 'company_id')
        };
    }
}

export default Provider;
